import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { StaffReportTypeEnum } from './staff.models'

export const exportStaffReport = createAction(
  '[Staff/API] Export Staff Report',
  props<{
    staffReportType: StaffReportTypeEnum
    startDate: string
    endDate: string
  }>(),
)

export const exportVoucherReport = createAction(
  '[Staff/API] Export Voucher Staff Report',
  props<{
    startDate: string
    endDate: string
  }>(),
)

export const openDownloadReportDialog = createAction(
  '[Staff/Dialog] Open Staff Report Download dialog',
  props<{
    staffReportType: StaffReportTypeEnum
    dialogTitle: string
  }>(),
)
export const downloadStaffReportSuccess = createAction('[Staff/API] Download Staff Report Success')

export const exportStaffReportSuccess = createAction('[Staff/API] Export Staff Report Success')

export const exportStaffReportFailure = createAction(
  '[Staff/API] Export Staff Report Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const createInvalidation = createAction('[Staff/API] Create invalidation')

export const createInvalidationSuccess = createAction('[Staff/API] Create invalidation Success')
export const createInvalidationFailure = createAction(
  '[Staff/API] Create invalidation Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const syncKnowledgeSources = createAction('[Staff/API] Sync knowledge sources')

export const syncKnowledgeSourcesSuccess = createAction('[Staff/API] Sync knowledge sources Success')
export const syncKnowledgeSourcesFailure = createAction(
  '[Staff/API] Sync knowledge sources Failure',
  props<{ error: HttpErrorResponse }>(),
)
